var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTtimLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 886.773,
    height: 1024,
    viewBox: "0 0 886.773 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 0.977,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa9c2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    stopColor: "#814d55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d0b77"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_481",
    "data-name": "Union 481",
    d: "M16934.5,3714.5V3202.5l443.379-256,162.457,93.833-75.066,58.062-87.086-50.437-355.418,205.275v174.085l308.492-172.322,108.5-60.116L17600,3105.971l-36.793-68.86,248.965,18.178-123.453,216.7-37.559-70.287-211.406,117.211v461.861l-55.133,30.786-53.367-30.786V3379.032l-308.492,172.323v112.413l355.418,205.274,355.406-205.274V3371.992l87.684-154.533V3714.5l-443.395,256Zm549.836-174.475,108.5-62.171v218.468l-108.5,60.115Zm-306.437,156v-179.46l35.48-18.774,73.012-38.7v297.054Zm306.438-342.5,108.5-57.478v126.968l-108.5,64.518Z",
    transform: "translate(-16934.5 -2946.5)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtimLogo);
export default __webpack_public_path__ + "static/media/ttim_logo.deeb8f5924d8de9623a327af8ec73b50.svg";
export { ForwardRef as ReactComponent };